import React from 'react';

import { X } from 'lucide-react';

import { AccountCohort } from '../types';

import AccountCohortForm from './AccountCohortForm';

type AccountCohortFormModalProps = {
  onClose: () => void;
  onSaved: (cohort: AccountCohort) => void;
};

const AccountCohortFormModal: React.FC<AccountCohortFormModalProps> = ({ onClose, onSaved }) => (
  <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center">
    <div className="rounded-2xl w-full max-w-2xl mx-4 max-h-[90vh] flex flex-col overflow-hidden bg-white shadow-2xl">
      <div className="flex items-center justify-end flex-shrink-0 px-3 pt-3">
        <button
          type="button"
          aria-label="Cerrar"
          className="btn btn-ghost p-1 text-gray-400"
          onClick={onClose}
        >
          <X size={18} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        <AccountCohortForm onSaved={onSaved} onArchived={onClose} />
      </div>
    </div>
  </div>
);

export default AccountCohortFormModal;
